export default {
    chartOptionsBar: {
        chartArea: { width: '80%', height: '80%' },
        titleTextStyle: {
            color: '#333333',
            fontSize: 16,
            fontName: 'Roboto',
        },
        legend: { position: 'bottom' },
        animation: {
            startup: true,
            duration: 700,
        },
        bars: 'horizontal',
        vAxis: {
            direction: '-1',
        },
        hAxis: {
            minValue: 0,
        },
    },
    chartOptionsPie: {
        titleTextStyle: {
            color: '#333333',
            fontSize: 16,
            fontName: 'Roboto',
        },
        chartArea: { width: '100%', height: '80%' },
        legend: { position: 'bottom' },
        animation: {
            startup: true,
            duration: 700,
            easing: 'out',
        },
        is3D: true,
        colors: ['#184DB4', '#2366E9', '#18A6D2', '#757575', '#BDBDBD'],
    },
};
